import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { Configuration } from './configuration';
import { HttpClient } from '@angular/common/http';

import { AdminService } from './api/admin.service';
import { AdminPaymentsService } from './api/adminPayments.service';
import { AdminProOrganizerRequestsService } from './api/adminProOrganizerRequests.service';
import { AdminReportsService } from './api/adminReports.service';
import { AdminUsersManagementService } from './api/adminUsersManagement.service';
import { AppService } from './api/app.service';
import { AuthService } from './api/auth.service';
import { CgvService } from './api/cgv.service';
import { CgvAcceptanceService } from './api/cgvAcceptance.service';
import { CgvAcceptanceHistoryService } from './api/cgvAcceptanceHistory.service';
import { CgvVersionsService } from './api/cgvVersions.service';
import { ChatsService } from './api/chats.service';
import { CommissionService } from './api/commission.service';
import { CommissionHistoryService } from './api/commissionHistory.service';
import { EventsService } from './api/events.service';
import { FollowingsService } from './api/followings.service';
import { GroupsService } from './api/groups.service';
import { HealthService } from './api/health.service';
import { MediaService } from './api/media.service';
import { NotificationsService } from './api/notifications.service';
import { OrganizersService } from './api/organizers.service';
import { PaymentsService } from './api/payments.service';
import { PremiumRoleService } from './api/premiumRole.service';
import { ProOrganizerRequestsService } from './api/proOrganizerRequests.service';
import { ProfileService } from './api/profile.service';
import { PromosService } from './api/promos.service';
import { RequestHistoryService } from './api/requestHistory.service';
import { SparringPartnerService } from './api/sparringPartner.service';
import { SportsService } from './api/sports.service';
import { StatusService } from './api/status.service';
import { SystemSettingService } from './api/systemSetting.service';
import { UsersService } from './api/users.service';

@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: []
})
export class ApiModule {
    public static forRoot(configurationFactory: () => Configuration): ModuleWithProviders<ApiModule> {
        return {
            ngModule: ApiModule,
            providers: [ { provide: Configuration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: ApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('ApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
